import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAppSettings } from "@/hooks/useAppSettings";
import { SettingsCategory } from "./SettingsCategory";
import { Loader2, Settings } from "lucide-react";

export function AppSettingsManager() {
  const { settings, loading, error, getSettingsByCategory } = useAppSettings();

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin" />
        <span className="ml-2">Cargando configuraciones...</span>
      </div>
    );
  }

  if (error) {
    return (
      <Card className="border-destructive">
        <CardHeader>
          <CardTitle className="text-destructive">Error</CardTitle>
          <CardDescription>
            No se pudieron cargar las configuraciones: {error}
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  // Obtener categorías únicas
  const categories = [...new Set(settings.map(s => s.category))];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Configuración de la Aplicación
          </CardTitle>
          <CardDescription>
            Gestiona el comportamiento de la aplicación desde esta interfaz centralizada.
            Los cambios se aplican inmediatamente.
          </CardDescription>
        </CardHeader>
      </Card>

      <Tabs defaultValue={categories[0]} className="space-y-4">
        <TabsList className="grid w-full grid-cols-3">
          {categories.map((category) => (
            <TabsTrigger key={category} value={category} className="capitalize">
              {getCategoryDisplayName(category)}
            </TabsTrigger>
          ))}
        </TabsList>

        {categories.map((category) => (
          <TabsContent key={category} value={category}>
            <SettingsCategory
              category={category}
              settings={getSettingsByCategory(category)}
              title={getCategoryDisplayName(category)}
              description={getCategoryDescription(category)}
            />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

function getCategoryDisplayName(category: string): string {
  const displayNames: Record<string, string> = {
    enrollment: 'Inscripciones',
    attendance: 'Asistencias',
    billing: 'Facturación',
    general: 'General',
  };
  return displayNames[category] || category;
}

function getCategoryDescription(category: string): string {
  const descriptions: Record<string, string> = {
    enrollment: 'Configuraciones relacionadas con el proceso de inscripción de estudiantes.',
    attendance: 'Configuraciones para el control de asistencias y puntualidad.',
    billing: 'Configuraciones del sistema de facturación y pagos.',
    general: 'Configuraciones generales de la aplicación.',
  };
  return descriptions[category] || '';
}